import { useEffect, useState, useRef } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
import get from "../functions/get.js";
import post from "../functions/post.js";
import { DummyLoader, ListLoader } from "../components/list_loader.jsx";
import Button from "../components/button.jsx";
import EditQuiz from "./edit_quiz.jsx";
import Loading from "../components/loading.jsx";

gsap.registerPlugin(CSSPlugin);

const CreateQuiz = () => {

    const location = useLocation();
    
    const [ mounted, setMounted ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ edit, setEdit ] = useState(false);
    const [ error, setError ] = useState("");
    const [ taskError, setTaskError ] = useState("");
    const [ quiz, setQuiz ] = useState({});
    const [ allQuestions, setAllQuestions ] = useState(false);
    const [ task, setTask ] = useState({
        sentence: "",
        type: "Kasus bestimmen"
    });

    const [ taskFinal, setTaskFinal ] = useState(false);
    const [ taskInfo, setTaskInfo ] = useState(null);
    
    const [ deleteQ, setDeleteQ ] = useState(false);

    const onRes = (res, data) => {

        setLoading(false);

        if (!res) {
            setError("Server nicht erreichbar!");
            return;
        }

        if (res.status === 200) {
            setQuiz(data);

            const url = location.pathname.split("/");
            const frage = url.findIndex(s => s === "frage");
            const frageID = frage >= 1 ? url[frage + 1] : null;

            if (frageID) {
                setTaskFinal(true);
                const info = {
                    id: data.id,
                    ...data.questions[frageID - 1],
                }
                setTaskInfo(info);
                setEdit(true);
            } else {
                setTaskFinal(false);
                setEdit(false);
            }

        } else {
            setError("Dieses Quiz existiert nicht mehr!");
        }
    }

    useEffect(() => {

        setEdit(false);
        setError("");
        setTaskError("");
        setTaskFinal(false);

        const url = location.pathname.split("/");
        const currQuiz = url.findIndex(s => s === "quiz")

        const URL = Number(url[currQuiz + 1]);

        const frage = url.findIndex(s => s === "frage");
        const frageID = frage >= 1 ? Number(url[frage + 1]) : null;

        if (frageID && mounted) {
            setTaskFinal(true);
            const info = {
                id: quiz.id,
                ...quiz.questions[frageID - 1],
            }
            setTaskInfo(info);
            setEdit(true);
        }

        if (location.pathname.includes("bearbeiten") && !mounted) {
            setMounted(true);
            setLoading(true);
            get(`/admin/get/quiz?id=${URL}`, onRes, onRes);
        }

    }, [location.pathname]);

    const handleTaskChange = (field, value) => {
        if (field === "sentence" && value.length > 100) return;

        setTask(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const postQuestion = () => {

        if (task.sentence === "") {
            setTaskError("Bitte gib einen vollständigen Satz an!");
            return;
        } else if (task.type === "") {
            setTaskError("Bitte wähle einen Aufgaben-Typ aus!");
            return;
        }

        const body = {
            ...task,
            "id": quiz.id
        }

        setLoading(true);
        post("/create/quiz/question", body, (res, data) => {

            setLoading(false);

            if(!res) {
                setError("Server nicht erreichbar!")
                return;
            }

            if (res.status === 200) {
                setTaskFinal(true);
                setTaskInfo(data);
            } else {
                setTaskError(data?.error || "Fehler beim Erstellen der Frage.");
            }
        }, (res, data) => {
                setLoading(false);
                setTaskError(data?.error || "Fehler beim Erstellen der Frage.");
        });

    };

    const navigate = useNavigate();
    
    const handleDelete = () => {

        setError("");
        setTaskError("");
        setDeleteQ(false);
        setLoading(true);
        navigate("/admin/quizzes");

        post("/delete/quiz", quiz.id, (res, data) => {

            setLoading(false);

            if(!res) {
                setError("Server nicht erreichbar!")
                return;
            }

            if (res.status === 200) {
                setTaskError("Quiz wurde erfolgreich gelöscht!");
            } else {
                setTaskError(data?.error || "Ups, etwas ist schiefgelaufen!");
            }
        }, (res, data) => {
                setLoading(false);
                setTaskError(data?.error || "Ups, etwas ist schiefgelaufen!");
        });


    };

    const handleSucces = (data) => {
        setTaskFinal(false);
        setTask({
            sentence: "",
            type: "Kasus bestimmen",
        });
        setTaskInfo({
            sentence: "",
            task: "",
        });
        setQuiz(data);
        setTaskError("Dein Quiz ist auf dem neuesten Stand!")
    };

    const handleFail = () => {
        setTaskFinal(false);
        setTaskInfo({
            sentence: "",
            task: "",
        });
        setTaskError("Beim Erstelllen der Frage ist ein unerwarteter Fehler aufgetreten!")
    };

    const [formData, setFormData] = useState({
        name: "",
        difficulty: "",
        category: "Verben",
        description: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setError("");
    };

    const onFormRes = (res, data) => {

        setLoading(false);
        if(!res) {
            setError("Server nicht erreichbar!");
            return;
        }

        if(res.status === 200) {
            navigate("/admin/quizzes");
        } else {
            setTaskError("Dein Quiz konnte nicht erstellt werden!");
        }

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.name.trim() || !formData.difficulty.trim()) {
            setTaskError("Name und Schwierigkeit müssen angegeben werden.");
            return;
        }

        setLoading(true);
        setTaskError("");
        post("/create/quiz", formData, onFormRes, onFormRes);
    };

    if (error) {
        return (
            <div className="start-warning">
                <p>{error}</p>
            </div>
        );
    }

    if(taskFinal) {
        return (
            <EditQuiz info={taskInfo} allQuestions={quiz.questions} buttonOne={() => setTaskFinal(false)} onSuccess={handleSucces} onFail={handleFail} edit={edit ? true : false} />
        );
    }

    if (loading) {
        return (
            <div 
            className="flex-row"
            style={{
                height: "calc(100vh - 160px)",
                width: "100%",
            }}>
                <Loading />
            </div>
        );
    }

    return (
        <div>
            {(!location.pathname.includes("bearbeiten") && !location.pathname.includes("erstellen")) &&
                <>
                    <h2>QUIZ BEARBEITEN</h2>
                    <ListLoader url="/admin/get/quiz" buttonText="Neues Quiz" buttonRedirect = "erstellen" redirect="bearbeiten/quiz" />
                </>
            }

            {location.pathname.includes("erstellen") &&
                <div>
                    <h2>QUIZ ERSTELLEN</h2>

                    <p>Gib deinem Quiz einen Namen und füge es einer passenden Kategorie hinzu. Optional kannst du noch einen Kurzbeschreib hinzufügen.</p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-elem">
                            <label>Name: </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Name..."
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-elem">
                            <label>Schwierigkeit: </label>
                            <input
                                type="text"
                                name="difficulty"
                                placeholder="z.B. 1–3"
                                value={formData.difficulty}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-elem">
                            <label>Kategorie: </label>
                            <select
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="Verben">Verben</option>
                                <option value="Nomen">Nomen</option>
                                <option value="Allgemein">Allgemein</option>
                            </select>
                        </div>

                        <div className="form-elem flex-col">
                            <label>Kurzbeschreib: </label>
                            <textarea
                                type="text"
                                name="description"
                                placeholder="Kurzbeschreib"
                                value={formData.description}
                                className="sentence-input"
                                onChange={handleChange}
                            />
                        </div>

                        {taskError && (
                            <div className="start-warning">
                                <p style={{marginTop: 0}}>{taskError}</p>
                            </div>
                        )}

                        <div style={{ marginTop: "10px" }}>
                            <Button
                                className="button-yellow"
                                text="Erstellen"
                                type="submit"
                            />
                        </div>
                    </form>

                </div>
            }

            {(location.pathname.includes("bearbeiten") && !location.pathname.includes("frage")) &&
                <>

                    {!loading &&

                        <div>
                            <h2>{allQuestions ? "FRAGE BEARBEITEN" : "QUIZ BEARBEITEN"}</h2>

                            {!allQuestions &&
                                <>
                                    <p>Füge deinem Quiz bis zu 20 einzelne Aufgaben hinzu! Es ist super einfach: Gib unten einen Satz ein, wähle eine der möglichen Aufgabenstellungen aus und los geht die Magie.</p>

                                    <div className="exercise-elem">
                                        <label>Satz: </label>
                                        <textarea 
                                        value={task.sentence}
                                        onChange={(e) => handleTaskChange("sentence", e.target.value)}
                                        className="sentence-input" />
                                    </div>

                                    <div className="exercise-elem">
                                        <label>Aufgaben-Typ: </label>
                                        <select 
                                            style={{ marginLeft: 0 }}
                                            value={task.type}
                                            onChange={(e) => handleTaskChange("type", e.target.value)}
                                        >
                                            <option value="Kasus bestimmen">Kasus bestimmen</option>
                                            <option value="Subjekt bestimmen">Subjekt bestimmen</option>
                                            <option value="Objekte finden">Objekte finden</option>
                                        </select>
                                    </div>

                                    <div onClick={postQuestion}>
                                        <Button className="button-yellow" text="Frage hinzufügen" />
                                    </div>

                                    <div className="flex-row exercise-del">
                                        <div onClick={() => setAllQuestions(true)}>
                                            <Button className="button-blue" text="Alle Fragen" />
                                        </div>

                                        <div onClick={() => setDeleteQ(true)}>
                                            <Button className="button-blue" text="Quiz löschen" />
                                        </div>
                                    </div>

                                    {taskError &&
                                        <div className="start-warning">
                                            <p>{taskError}</p>
                                        </div>
                                    }
                                </>
                            }

                            {allQuestions &&
                                <>
                                    <p style={{
                                        marginTop: "30px"
                                    }}>Fragen: </p>
                                    {Array.isArray(quiz.questions) &&
                                        <div style={{maxHeight: "65vh", overflow: "auto"}}>
                                            {quiz?.questions?.map((q, i) => {

                                                return (
                                                    <Link
                                                    to={`frage/${i + 1}`} 
                                                    key={i}
                                                    >
                                                        <p style={{marginTop: i !== 0 ? "30px" : "5px"}}>{q.question_text}</p>

                                                        <p>{q.sentence}</p>

                                                        <p style={{
                                                            color: "var(--yellow)",
                                                        }}
                                                        >Bearbeiten <span 
                                                        style={{
                                                            display: "inline-block"
                                                        }}
                                                        >{">"}</span></p>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    }

                                    <div className="fixed-button" onClick={() => setAllQuestions(false)}>
                                        <Button className="button-yellow" text="Zurück" />
                                    </div>
                                </>
                            }

                            {deleteQ &&
                                <div className="confirmation">
                                    <div style={{width: "auto", maxWidth: "80vw"}}>
                                        <p>Möchtest du dieses Quiz wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.</p>

                                        <div className="flex-row" style={{justifyContent: "flex-start"}}>
                                            <button className="button-yellow" onClick={handleDelete}>Ja</button>
                                            <button className="button-blue" onClick={() => setDeleteQ(false)}>Nein</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            }

                        </div>

                    }
                </>
            }

        </div>
    );

}; export default CreateQuiz;